import { onMounted, ref } from "vue";
import { UserDataService } from "@/services";

export interface CoordinatorOption {
  id: string;
  name?: string;
  surname?: string;
  fullName?: string;
}

/**
 * Only users with ENTITY_APPROVAL_COORDINATE from the current directorate.
 */
export function useCoordinatorOptions() {
  const coordinators = ref<CoordinatorOption[]>([]);
  const loading = ref(false);

  const loadCoordinators = async () => {
    loading.value = true;
    try {
      const response = await UserDataService.getCoordinators();
      const data = response.data?.data ?? response.data ?? [];
      const list = Array.isArray(data) ? data : data.list ?? data.items ?? [];
      coordinators.value = list.map((item: any) => {
        const fullName = String(item.fullName || item.name || "").trim();
        const parts = fullName.split(/\s+/).filter(Boolean);
        return {
          id: String(item.id),
          fullName,
          name: parts[0] || fullName,
          surname: parts.slice(1).join(" ") || "",
        };
      });
    } finally {
      loading.value = false;
    }
  };

  onMounted(loadCoordinators);

  return { coordinators, loading, loadCoordinators };
}
